import { render, staticRenderFns } from "./EnvForm.vue?vue&type=template&id=5cbc6a34&"
import script from "./EnvForm.vue?vue&type=script&lang=js&"
export * from "./EnvForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbc6a34')) {
      api.createRecord('5cbc6a34', component.options)
    } else {
      api.reload('5cbc6a34', component.options)
    }
    module.hot.accept("./EnvForm.vue?vue&type=template&id=5cbc6a34&", function () {
      api.rerender('5cbc6a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/EnvForm.vue"
export default component.exports